/**
 * @file 成长中心AI助手入口
 * @author izzieyspu
 */

import React, { useCallback } from 'react';
import { Button } from '@tencent/spaui';

import { hasFeatureFlag } from '@/services';
import { TrackType } from '@/pages/agency/growup/dashboard/model';

import useAIAssistant from '../../hooks/use-ai-assistant';
import { AGENT_ID, FEATURE_TYPE, AI_ASSISTANT_REPORT_EVENT_NAME } from '../../constants';
import { GrowupReportType } from './constants';

interface GrowupEntryProps {
  type: GrowupReportType;
  track: TrackType;
}

export default (props: GrowupEntryProps) => {
  const { type, track } = props;

  const { showAIAssistant, aiAssistantModal } = useAIAssistant();
  // 唤起AI助手
  const handleAIAssistantShow = useCallback(() => {
    showAIAssistant({
      targetAgentId: AGENT_ID.GROWUP,
      defaultFeatureType: FEATURE_TYPE.GROWUP_REPORT,
    });
  }, [showAIAssistant]);

  if (!hasFeatureFlag('is_enable_ai_assistent') || !type) {
    return null;
  }

  return (
    <>
      {aiAssistantModal}
      <Button
        displayType='primary'
        shape="round"
        size="small"
        onClick={handleAIAssistantShow}
        data-report={`${AI_ASSISTANT_REPORT_EVENT_NAME.GROWUP_ENTRY}__${track}`}
        data-report-extra={`relation_key:${track}`}
        className="tw-absolute tw-bottom-0 tw-right-0"
      >
        生成AI报告
      </Button>
    </>
  );
};
